import * as types from 'modules/notifications/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @typedef {{
 *   [id: string]: boolean
 * }} State
 */

/** @type {State} state */
const initialState = {};

/** @returns {State} `true` */
const isLoading = (state, { payload }) => ({ ...state, [payload.notificationId]: true });

/** @returns {State} `false` */
const endLoading = (state, { payload: notificationId }) => ({
  ...state,
  [notificationId]: false,
});

/** @returns {State} `false` */
const endConfigurationLoading = (state, { payload }) => endLoading(state, { payload: payload.notificationId });

export default createReducer(initialState, {
  [types.MARK_AS_READ]: isLoading,
  [types.MARK_AS_UNREAD]: isLoading,
  [types.DELETE_NOTIFICATION]: isLoading,
  [types.PATCH_CONFIGURATION]: isLoading,
  [types.MARK_AS_READ_SUCCESS]: endLoading,
  [types.MARK_AS_READ_FAILURE]: endLoading,
  [types.MARK_AS_UNREAD_SUCCESS]: endLoading,
  [types.MARK_AS_UNREAD_FAILURE]: endLoading,
  [types.DELETE_NOTIFICATION_SUCCESS]: endLoading,
  [types.DELETE_NOTIFICATION_FAILURE]: endLoading,
  [types.PATCH_CONFIGURATION_SUCCESS]: endConfigurationLoading,
  [types.PATCH_CONFIGURATION_FAILURE]: endConfigurationLoading,
});
